import { useEffect } from "react";
import { create } from "zustand";
import { produce } from "immer";
import axios from "axios";

export const useCartStore = create((set, get) => ({
  init: false,
  cart: null,
  setCart: (cart) => set((state) => ({ cart, init: true })),
  fetchCart: async () => {
    try {
      const response = await axios.get("/cart.js");
      const data = response.data;

      set(
        produce((draft) => {
          draft.cart = data;
        })
      );
    } catch (error) {
      console.log(`Error fetching cart: ${error}`);
      console.log(error);
    }
  },
  addItems: async (items) => {
    try {
      const response = await axios.post("/cart/add.js", {
        items,
        sections: ["cart-badge"],
      });

      const data = response.data;
      const { sections } = data;

      if (sections && sections["cart-badge"]) {
        const badgeElements = document.querySelectorAll(".cart-badge");

        badgeElements.forEach((badgeElement) => {
          badgeElement.innerHTML = sections["cart-badge"];
        });
      }

      set(
        produce((draft) => {
          // find item in cart with id of draft.items
          data.items.forEach((item) => {
            const itemIndex = draft.cart.items.findIndex(
              (cartItem) => cartItem.id === item.id
            );

            if (itemIndex > -1) {
              draft.cart.items[itemIndex] = item;
            } else {
              draft.cart.items.push(item);
            }
          });
        })
      );

      window?.Alpine.store("toast").create(
        window?.$t("cart.added_item"),
        "cart"
      );

      return data;
    } catch (error) {
      console.log(`Error adding items to cart: ${error}`);
      console.log(error);
      return null;
    }
  },
}));

export default function CartProvider({ defaultValue }) {
  const cartStore = useCartStore();
  const { cart, setCart } = cartStore;

  useEffect(() => {
    async function fetchCart() {
      const requestCart = axios.get(`${window.Shopify.routes.root}cart.js`);
      const requestAdditional = axios.get("/cart?view=wooltari");

      const [cartResponse, additionalResponse] = await Promise.all([
        requestCart,
        requestAdditional,
      ]);

      let payload = {};

      console.log({ cartResponse });

      // if (cartResponse.status === 200 && additionalResponse.status === 200) {
      //   const cartData = cartResponse.data;
      //   const additional = additionalResponse.data;

      //   payload = {
      //     ...cartData,
      //     items: map(cartData.items, (item) => {
      //       return merge(item, find(additional, { id: item.id }));
      //     }),
      //   };
      // }

      setCart(cartResponse.data);
      // useCartStore.setState(
      //   produce((state) => {
      //     state.setCart(payload);
      //   })
      // );
    }

    setCart(defaultValue);
    // fetchCart();
  }, []);

  return null;
}
